var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHide = function SvgHide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2E3330",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m3.808 20.131 16.667-16M9.302 18.399a8.9 8.9 0 0 0 2.699.399c3.644.061 7.34-2.5 9.621-5.011a1.48 1.48 0 0 0 0-1.979 18.3 18.3 0 0 0-2.732-2.45m-4.744-2.31A8.5 8.5 0 0 0 12 6.798c-3.584-.06-7.29 2.446-9.62 5.008a1.48 1.48 0 0 0 0 1.98q1.066 1.164 2.312 2.133m3.974-3.122a3.333 3.333 0 0 1 3.334-3.333m3.333 3.333a3.335 3.335 0 0 1-3.333 3.334"
  })));
};
export default SvgHide;